import { render } from "./VendorsChargesIndexTable.vue?vue&type=template&id=659b094a"
import script from "./VendorsChargesIndexTable.vue?vue&type=script&lang=js"
export * from "./VendorsChargesIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__